module.exports = __webpack_public_path__ + "img/google-play-store.9bcd917d.svg";